import { Watermark } from 'antd';
import React from 'react';
import { Outlet } from 'react-router';
import { StyledAuthContainer } from './styled';

const Auth = () => {
  return (
    <Watermark content="Promethée" zIndex={0}>
      <StyledAuthContainer>
        <Outlet />
      </StyledAuthContainer>
    </Watermark>
  );
};

export default Auth;
